module.exports = __webpack_public_path__ + "img/logo.eb7c07fc.png";